import React from 'react';
import { Table } from 'antd';

export default function Cuotas(props) {
    return (
        <div>
            <Table
                style={{ overflowX: 'auto' }}
                className={'table-cuota'}
                size="small"
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                columns={[
                    {
                        title: 'Couta',
                        dataIndex: 'correlativo',
                        key: 'correlativo',
                        align: 'center',
                        width: '100px'
                    },

                    {
                        title: 'Fecha Vencimiento',
                        dataIndex: 'fechaVencimientoStr',
                        key: 'fechaVencimientoStr',
                        align: 'center',
                    },
                    {
                        title: 'Monto de Cuota',
                        dataIndex: 'montoCuota',
                        key: 'montoCuota',
                        render: (value) => {

                            return <> {value.toFixed(2)}</>
                        }
                    },
                    {
                        title: 'Estado',
                        dataIndex: 'estado',
                        key: 'estado',
                    },
                ]}
            />
        </div>
    );
}